<template>
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[0.2fr,1fr,0.2fr] xl:grid-cols-[0.5fr,1fr,0.5fr]">
    <div></div>
    <footer class="max-w-screen-xl p-4 border-t">
      <div class="mb-1">오버케이(OverK) | 사업자번호 782-65-00284</div>
      <div class="mb-1">통신판매업 신고번호 2024-서울강남-06716</div>
      <div class="mb-1">주소 서울특별시 서초구 서초중앙로 146 503호 | 대표자 박선오 | 유선번호 0507-1338-3694</div>
      <div class="mt-4 flex justify-between flex-wrap">
        <RouterLink :to="{ name: 'terms' }" class="block me-12">이용약관</RouterLink>
        <RouterLink :to="{ name: 'privacy' }" class="block me-12">개인정보처리방침</RouterLink>
        <RouterLink :to="{ name: 'location' }" class="block me-12">위치기반서비스 이용약관</RouterLink>
        <RouterLink :to="{ name: 'faq' }" class="block me-12">FAQ</RouterLink>
        <a class="block" href="https://pf.kakao.com/_ixixoxen/chat" target="_blank">문의사항</a>
        <a class="block" href="https://www.instagram.com/tourdot_official" target="_blank">Instagram</a>
        <a class="block" href="https://www.facebook.com/profile.php?id=61575275255168&locale" target="_blank"
          >FaceBook</a
        >
        <a class="block" style="color: green" href="https://blog.naver.com/oi_event" target="_blank">Naver Blog</a>
      </div>
    </footer>
    <div></div>
  </div>
</template>
